export const arrayIsSap: any = [
    {
      slug: "yes",
      name: {
        en: "Yes",
        pt: "Sim"
      }
    },
    {
      slug: "no",
      name: {
        en: "No",
        pt: "Não"
      }
    }
  ]